<template>
  <div
    class="endTimeBody0"
    v-show="visbiliti == 0"
    v-if="(percentile == 0 && tenths == 0 && bits == 0)"
  >
    <div class="closeImg" @click="none()">
      <img src="../../src/static/closeEndTime.png" alt="" />
    </div>

    <div class="title">展会正式开幕</div>
  </div>

  <div class="endTimeBody1" v-else v-show="visbiliti == 0">
    <div class="title">距离展会开幕</div>
    <div class="closeImg" @click="none()">
      <img src="../../src/static/closeEndTime.png" alt="" />
    </div>
    <div class="number">
      <div class="item">{{ percentile }}</div>
      <div class="item">{{ tenths }}</div>
      <div class="item">{{ bits }}</div>
      <div class="day">天</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "guest",
  props: {
    endDate: {
      type: String,
      default: "2021-10-25",
      required: true,
    },
  },
  data() {
    return {
      endTime: this.endDate,
      percentile: 0, //百位
      tenths: 0, //十位
      bits: 0, //个位
      visbiliti: 0,
    };
  },
  methods: {
    none() {
      this.visbiliti = 1;
    },

    //计算剩余天数
    countDown(time) {
      let currentTime = new Date(); //获取最新时间
      let endTime = new Date(Date.parse(time.replace(/-/g, "/")));
      if (currentTime.getTime() > endTime.getTime()) {
        this.percentile = 0;
        this.tenths = 0;
        this.bits = 0;
        return false;
      } else {
        let dayCount = parseInt(
          Math.abs(currentTime.getTime() - endTime.getTime()) /
            1000 /
            60 /
            60 /
            24
        );
        this.dayAdjust(dayCount + 1); //时间日期进行格式化输出
      }
    },
    //根据天数调节是否加0
    dayAdjust(dayNumber) {
      let number = dayNumber;
      if (number >= 0 && number < 10) {
        //0-9的情况
        this.percentile = 0;
        this.tenths = 0;
        this.bits = number;
      } else if (number >= 10 && number < 100) {
        //10-99的情况
        let shiwei = parseInt((number % 100) / 10); //获取十位的数字
        let gewei = parseInt(number % 10); //获取个位的数字
        this.percentile = 0;
        this.tenths = shiwei;
        this.bits = gewei;
      } else if (number >= 100 && number < 1000) {
        //100-999的情况
        let baiwei = parseInt(number / 100); //获取百位的数字
        let shiwei = parseInt((number % 100) / 10); //获取十位的数字
        let gewei = parseInt(number % 10); //获取个位的数字
        this.percentile = baiwei;
        this.tenths = shiwei;
        this.bits = gewei;
      } else {
        console.log("计算出错");
      }
    },
  },
  created() {
    this.countDown(this.endTime);
  },
  //以下代码毫无屁用,可删可不删
  watch: {
    endDate(newValue, oldValue) {
      if (newValue != oldValue) {
        this.countDown(newValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.endTimeBody0 {
  width: 100%;
  background: rgba(0, 111, 184, 0.9);
  border-radius: 2.7vw;
  position: relative;
  height: 16.6vw;
  .closeImg {
    width: 2.9vw;
    height: 2.9vw;
    position: absolute;
    top: 2.66vw;
    right: 2.66vw;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: 5.7vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fdd000;
    display: flex;
    justify-content: center;
    align-items: center;
      height: 16.6vw;
  }
  .number {
    width: 100%;
    margin-top: 3.4vw;
    display: flex;
    justify-content: center;
    padding-left: 9.2vw;
    box-sizing: border-box;
    padding-bottom: 4vw;
    .item {
      width: 11.7vw;
      height: 16vw;
      background: #ffffff;
      border-radius: 1.6vw;
      text-align: center;
      font-size: 11.7vw;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #006fb8;
      margin-right: 1.3vw;
      background-color: white;
    }
    .day {
      display: flex;
      align-items: flex-end;
      font-size: 3.7vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fdd000;
      line-height: 5.3vw;
      padding-bottom: 0.8vw;
    }
  }
}

.endTimeBody1 {
  width: 100%;
  height: 100%;
  background: rgba(0, 111, 184, 0.9);
  border-radius: 8px;
  border-radius: 2.7vw;
  position: relative;
  .closeImg {
    width: 2.9vw;
    height: 2.9vw;
    position: absolute;
    top: 2.66vw;
    right: 2.66vw;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .title {
    padding-top: 3.2vw;
    width: 100%;
    text-align: center;
    font-size: 3.8vw;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fdd000;
    padding-bottom: 2vw;

  }
  .number {
    width: 100%;
    margin-top: 3.4vw;
    display: flex;
    justify-content: center;
    padding-left: 9.2vw;
    box-sizing: border-box;
    padding-bottom: 4vw;

    .item {
      width: 11.7vw;
      height: 16vw;
      background: #ffffff;
      border-radius: 1.6vw;
      text-align: center;
      font-size: 11.7vw;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #006fb8;
      margin-right: 1.3vw;
      background-color: white;
    }
    .day {
      display: flex;
      align-items: flex-end;
      font-size: 3.7vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fdd000;
      line-height: 5.3vw;
      padding-bottom: 0.8vw;
    }
  }
}
</style>
